var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button } from '../UI/Button';
import { useNavigate } from 'react-router-dom';
import { routes } from '../../config/routes';
var NotFound = function () {
    var navigate = useNavigate();
    return (_jsx("div", __assign({ className: "flex items-center justify-center min-h-[400px] px-4" }, { children: _jsxs("div", __assign({ className: "text-center space-y-4" }, { children: [_jsx("h2", __assign({ className: "text-2xl font-bold" }, { children: "Page not found" })), _jsx("p", __assign({ className: "text-muted-foreground" }, { children: "The page you are looking for doesn\u2019t exist." })), _jsx(Button, __assign({ onClick: function () { return navigate(routes.home); } }, { children: "Go home" }))] })) })));
};
export default NotFound;
